import { client, gql } from 'data-provider';

export interface IAttribute {
  id: string;
  name: string;
  type: 'text' | 'float' | 'boolean' | 'dropdown';
  options: string[];
  required: boolean;
  allowCustomValue: boolean;
}

export interface ITemplate {
  id: string;
  name: string;
  description: string;
  productAttribute: IAttribute[];
}

export const getTemplates = async () => {
  const query = gql`
    query {
      productTemplatesDropdown {
        id
        name
        description
        productAttribute {
          id
          name
          type
          options
          required
          allowCustomValue
        }
      }
    }
  `;

  const response = await client.request(query);
  return response.productTemplatesDropdown as ITemplate[];
};

export interface ICreateTemplateData {
  name: string;
  description: string;
  attributes: {
    name: string;
    type: 'Text' | 'Boolean' | 'Float' | 'Dropdown';
    options: string[];
    required: boolean;
    allowCustomValue: boolean;
  }[];
}

export const createTemplate = async (data: ICreateTemplateData) => {
  const createReturn = gql`
    mutation ($input: createProductTemplateInput!) {
      createProductTemplate(input: $input) {
        id
        name
        description
        productAttribute {
          id
          name
          type
          options
          required
          allowCustomValue
        }
      }
    }
  `;

  const variables = {
    input: { data },
  };

  const createdData = await client.request(createReturn, variables);
  return createdData;
};

export const getTemplate = async (id: string) => {
  const query = gql`
    query ($productTemplateId: ID!) {
      productTemplate(id: $productTemplateId) {
        id
        name
        description
        productAttribute {
          id
          name
          type
          options
          required
          allowCustomValue
        }
      }
    }
  `;

  const variables = { productTemplateId: id };
  const data = await client.request(query, variables);
  return data.productTemplate as {
    id: string;
    name: string;
    description: string;
    productAttribute: IAttribute[];
  };
};

export const updateTemplate = async (id: string, data: { name: string; description: string }) => {
  const mutation = gql`
    mutation ($input: UpdateProductTemplateInput) {
      updateProductTemplate(input: $input) {
        id
        name
        description
      }
    }
  `;

  const variables = {
    input: {
      where: { id },
      data,
    },
  };
  const updatedData = await client.request(mutation, variables);
  return updatedData.updateProductTemplate as { id: string; name: string; description: string };
};

export const deleteTemplate = async (id: string) => {
  const mutation = gql`
    mutation ($input: deleteProductTemplateInput!) {
      deleteProductTemplate(input: $input) {
        productTemplate {
          id
        }
      }
    }
  `;

  const variables = {
    input: {
      where: { id },
    },
  };

  await client.request(mutation, variables);
};

export const getTemplatesOfProduct = async (productId: string) => {
  const query = gql`
    query ($productId: ID!) {
      TemplatesOfProduct(productId: $productId) {
        id
        name
        description
        productAttribute {
          id
          name
          type
          required
          allowCustomValue
          options
        }
      }
    }
  `;

  const variables = { productId };
  const response = await client.request(query, variables);
  return response.TemplatesOfProduct as ITemplate[];
};

export interface AddTemplateAttributeData {
  product_template_id: string;
  name: string;
  type: 'Text' | 'Boolean' | 'Float' | 'Dropdown';
  options: string[];
  required: boolean;
  allowCustomValue: boolean;
}

export const addTemplateAttribute = async (data: AddTemplateAttributeData) => {
  const mutation = gql`
    mutation Mutation($input: createProductAttributeInput!) {
      createProductTemplateAttribute(input: $input) {
        id
        name
        type
        required
        allowCustomValue
        options
      }
    }
  `;

  const variables = {
    input: {
      data,
    },
  };
  const updatedData = await client.request(mutation, variables);
  return updatedData.createProductTemplateAttribute as IAttribute;
};

export const updateTemplateAttribute = async (id: string, data: AddTemplateAttributeData) => {
  const mutation = gql`
    mutation ($input: UpdateProductAttributeInput!) {
      updateProductTemplateAttribute(input: $input) {
        id
        name
        type
        required
        allowCustomValue
        options
      }
    }
  `;

  const variables = {
    input: {
      where: { id },
      data,
    },
  };
  const updatedData = await client.request(mutation, variables);
  return updatedData.updateProductTemplateAttribute as IAttribute;
};

export const deleteAttribute = async (id: string) => {
  const mutation = gql`
    mutation ($input: deleteProductAttributeInput!) {
      deleteProductTemplateAttribute(input: $input) {
        productTemplateAttribute {
          id
        }
      }
    }
  `;

  const variables = {
    input: {
      where: { id },
    },
  };

  await client.request(mutation, variables);
};
